module.exports = __webpack_public_path__ + "static/media/icon-social-saved.5f7c26a5.svg";